import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_06f857be from 'nuxt_plugin_plugin_06f857be' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_3a005b98 from 'nuxt_plugin_sentryserver_3a005b98' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_57722be0 from 'nuxt_plugin_sentryclient_57722be0' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_vuesocialsharingplugin_0584b8cd from 'nuxt_plugin_vuesocialsharingplugin_0584b8cd' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_pluginclient_a627d78c from 'nuxt_plugin_pluginclient_a627d78c' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_12a585c2 from 'nuxt_plugin_pluginserver_12a585c2' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_gtm_3a945baa from 'nuxt_plugin_gtm_3a945baa' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_4801afd4 from 'nuxt_plugin_axios_4801afd4' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_fontawesome_bebd57d4 from 'nuxt_plugin_fontawesome_bebd57d4' // Source: ./fontawesome.js (mode: 'all')
import nuxt_plugin_axiosinit_2748d806 from 'nuxt_plugin_axiosinit_2748d806' // Source: ../../../plugins/axios-init (mode: 'all')
import nuxt_plugin_cookiesclient_e5aac3a6 from 'nuxt_plugin_cookiesclient_e5aac3a6' // Source: ../../../plugins/cookies.client.ts (mode: 'client')
import nuxt_plugin_kiptailwindtheme_1e904336 from 'nuxt_plugin_kiptailwindtheme_1e904336' // Source: ../../../plugins/kip-tailwind-theme (mode: 'all')
import nuxt_plugin_kiphelpers_7f5fb554 from 'nuxt_plugin_kiphelpers_7f5fb554' // Source: ../../../plugins/kip-helpers (mode: 'all')
import nuxt_plugin_mixinapierrorhandlers_85c76a3a from 'nuxt_plugin_mixinapierrorhandlers_85c76a3a' // Source: ../../../plugins/mixin-api-error-handlers (mode: 'all')
import nuxt_plugin_errorcatcher_12b69e14 from 'nuxt_plugin_errorcatcher_12b69e14' // Source: ../../../plugins/error-catcher.plugin (mode: 'all')
import nuxt_plugin_vodal_31ba9861 from 'nuxt_plugin_vodal_31ba9861' // Source: ../../../plugins/vodal.plugin (mode: 'all')
import nuxt_plugin_vcalendar_27bf2854 from 'nuxt_plugin_vcalendar_27bf2854' // Source: ../../../plugins/v-calendar.plugin (mode: 'all')
import nuxt_plugin_vuesingleselect_2afaaa06 from 'nuxt_plugin_vuesingleselect_2afaaa06' // Source: ../../../plugins/vue-single-select.plugin (mode: 'all')
import nuxt_plugin_maska_6c470ac2 from 'nuxt_plugin_maska_6c470ac2' // Source: ../../../plugins/maska.plugin (mode: 'all')
import nuxt_plugin_vclickoutside_1b6a0324 from 'nuxt_plugin_vclickoutside_1b6a0324' // Source: ../../../plugins/v-click-outside.plugin (mode: 'all')
import nuxt_plugin_vswiped_6b0535ea from 'nuxt_plugin_vswiped_6b0535ea' // Source: ../../../plugins/v-swiped.plugin (mode: 'all')
import nuxt_plugin_app_9d6c38d4 from 'nuxt_plugin_app_9d6c38d4' // Source: ../../../plugins/app.plugin (mode: 'all')
import nuxt_plugin_auth_467aa248 from 'nuxt_plugin_auth_467aa248' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_storevuexwrapperinit_69773623 from 'nuxt_plugin_storevuexwrapperinit_69773623' // Source: ../../../plugins/store-vuex-wrapper-init (mode: 'all')
import nuxt_plugin_auth_bdbc1db4 from 'nuxt_plugin_auth_bdbc1db4' // Source: ../../../plugins/auth.configuration (mode: 'all')
import nuxt_plugin_authuserinject_67bc80a4 from 'nuxt_plugin_authuserinject_67bc80a4' // Source: ../../../plugins/auth-user-inject (mode: 'all')
import nuxt_plugin_apiinit_29fb9259 from 'nuxt_plugin_apiinit_29fb9259' // Source: ../../../plugins/api-init (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Kupuj i Pomagaj!","htmlAttrs":{"lang":"pl"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Kupuj i Pomagaj! - Rób zakupy w internecie, płać tyle co zawsze i wspieraj osoby niepełnosprawne!"},{"name":"google-site-verification","content":"LKF-ba_dRQc_eUwBQMVqwUMV6jaw5ezzNE2HfHeHhE0"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fwww.kupujipomagaj.pl\u002Fimages\u002Fbackgrounds\u002Fheader-desktop.png"},{"hid":"og:image:width","property":"og:image:width","content":"200"},{"hid":"og:image:height","property":"og:image:height","content":"200"},{"hid":"og:description","property":"og:description","content":"Kupuj i Pomagaj! - Rób zakupy w internecie, płać tyle co zawsze i wspieraj osoby niepełnosprawne!"}],"link":[{"rel":"manifest","href":"\u002Fmanifest.json"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon.png"},{"hid":"gf-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"gf-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"gf-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Mulish:wght@400;500;600;700;800;900&family=Montserrat:wght@400;500;600;700;900"}],"script":[{"id":"ipresso-prod","type":"text\u002Fplain","data-cookieconsent":"preferences","async":true,"innerHTML":"function __ipGetMonitCode(t){for(var e=\"__ipcan_nsssF5qua7BJ12uCFsfwCjrK5tVu6R8GvqNi0qgsXF0.=\",n=document.cookie.split(\";\"),o=\"null\",i=0;i\u003Cn.length;i++){var r;r=\"function\"!=typeof String.prototype.trim?n[i].replace(\u002F^s+|s+$\u002Fg,\"\"):n[i].trim(),0==r.indexOf(e)&&(o=r.substring(e.length,r.length))}var a=document.getElementById(\"ipressoMonitStart\");if(null!=a)try{document.getElementsByTagName(\"head\")[0].removeChild(a)}catch(f){}var c=document.getElementsByTagName(\"script\")[0],m=document.createElement(\"script\");m.type=\"text\u002Fjavascript\",m.id=\"ipressoMonitStart\",m.async=!0,t=t===!0?1:0,m.src=\"\u002F\u002Fkupujipomagaj-media.ipresso.com\u002Fmonitoridentification\u002FnsssF5qua7BJ12uCFsfwCjrK5tVu6R8GvqNi0qgsXF0.\u002FJQekJcrSUfXPmawNevV0aYYbstVCFLdo1XhfqA1NJ_s.\u002Fmonitoridentification.js?r=\"+encodeURIComponent(document.referrer)+\"&s=\"+encodeURIComponent(document.location.href.replace(document.location.hash,\"\"))+\"&ti=\"+encodeURIComponent(document.title)+\"&c=\"+o+\"&z=6MtCa28wYQvn8Om8PCauvpDzqcNYeNmcKJHmjw4qhdE.&as=\"+t,c.parentNode.insertBefore(m,c)}function __ipStartMonitoring(t){\"undefined\"!=typeof __ipIntervalTu&&__ipIntervalTu&&clearInterval(__ipIntervalTu),__ipGetMonitCode(t)}__ipStartMonitoring(!0);"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KXBQXP7')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"},{"hid":"gf-script","innerHTML":"(function(){var l=document.createElement('link');l.rel=\"stylesheet\";l.href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Mulish:wght@400;500;600;700;800;900&family=Montserrat:wght@400;500;600;700;900\";document.querySelector(\"head\").appendChild(l);})();"}],"__dangerouslyDisableSanitizers":["script"],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-KXBQXP7&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"},{"hid":"gf-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Mulish:wght@400;500;600;700;800;900&family=Montserrat:wght@400;500;600;700;900\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"],"gf-script":["innerHTML"],"gf-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_06f857be === 'function') {
    await nuxt_plugin_plugin_06f857be(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_3a005b98 === 'function') {
    await nuxt_plugin_sentryserver_3a005b98(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_57722be0 === 'function') {
    await nuxt_plugin_sentryclient_57722be0(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_0584b8cd === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_0584b8cd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_a627d78c === 'function') {
    await nuxt_plugin_pluginclient_a627d78c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_12a585c2 === 'function') {
    await nuxt_plugin_pluginserver_12a585c2(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_3a945baa === 'function') {
    await nuxt_plugin_gtm_3a945baa(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_4801afd4 === 'function') {
    await nuxt_plugin_axios_4801afd4(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_bebd57d4 === 'function') {
    await nuxt_plugin_fontawesome_bebd57d4(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosinit_2748d806 === 'function') {
    await nuxt_plugin_axiosinit_2748d806(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookiesclient_e5aac3a6 === 'function') {
    await nuxt_plugin_cookiesclient_e5aac3a6(app.context, inject)
  }

  if (typeof nuxt_plugin_kiptailwindtheme_1e904336 === 'function') {
    await nuxt_plugin_kiptailwindtheme_1e904336(app.context, inject)
  }

  if (typeof nuxt_plugin_kiphelpers_7f5fb554 === 'function') {
    await nuxt_plugin_kiphelpers_7f5fb554(app.context, inject)
  }

  if (typeof nuxt_plugin_mixinapierrorhandlers_85c76a3a === 'function') {
    await nuxt_plugin_mixinapierrorhandlers_85c76a3a(app.context, inject)
  }

  if (typeof nuxt_plugin_errorcatcher_12b69e14 === 'function') {
    await nuxt_plugin_errorcatcher_12b69e14(app.context, inject)
  }

  if (typeof nuxt_plugin_vodal_31ba9861 === 'function') {
    await nuxt_plugin_vodal_31ba9861(app.context, inject)
  }

  if (typeof nuxt_plugin_vcalendar_27bf2854 === 'function') {
    await nuxt_plugin_vcalendar_27bf2854(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesingleselect_2afaaa06 === 'function') {
    await nuxt_plugin_vuesingleselect_2afaaa06(app.context, inject)
  }

  if (typeof nuxt_plugin_maska_6c470ac2 === 'function') {
    await nuxt_plugin_maska_6c470ac2(app.context, inject)
  }

  if (typeof nuxt_plugin_vclickoutside_1b6a0324 === 'function') {
    await nuxt_plugin_vclickoutside_1b6a0324(app.context, inject)
  }

  if (typeof nuxt_plugin_vswiped_6b0535ea === 'function') {
    await nuxt_plugin_vswiped_6b0535ea(app.context, inject)
  }

  if (typeof nuxt_plugin_app_9d6c38d4 === 'function') {
    await nuxt_plugin_app_9d6c38d4(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_467aa248 === 'function') {
    await nuxt_plugin_auth_467aa248(app.context, inject)
  }

  if (typeof nuxt_plugin_storevuexwrapperinit_69773623 === 'function') {
    await nuxt_plugin_storevuexwrapperinit_69773623(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_bdbc1db4 === 'function') {
    await nuxt_plugin_auth_bdbc1db4(app.context, inject)
  }

  if (typeof nuxt_plugin_authuserinject_67bc80a4 === 'function') {
    await nuxt_plugin_authuserinject_67bc80a4(app.context, inject)
  }

  if (typeof nuxt_plugin_apiinit_29fb9259 === 'function') {
    await nuxt_plugin_apiinit_29fb9259(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
